export const rules = {
    full_name: [{
        required: true,
        message: 'Пожалуйста, введите название ',
        trigger: 'change'
    },]
};
